<style lang="less" scoped>
    .detail-from-input {
        width: 450px;
        margin: 10px 30px;
    }

    .detail-form-logo {
        margin: 16px 20px;
    }

    .margin-bt-10 {
        margin-bottom: 40px;
    }

    .detail-body-title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .upload-logo {
        width: 30%;
    }

    .app-card-style img {
        width: 350px;
        height: 160px;
        border-radius: 5px;
        cursor: pointer;
    }

    .app-card-style {
        display: flex;
        flex-direction: column;
    }

    .box {
        position: relative;
        width: 348px;
        height: 160px;
        overflow: hidden;
        border: 3px solid #4390df;
        border-radius: 6px;

    }

    .box:before {
        position: absolute;
        display: block;
        border-top: 20px solid #4390df;
        border-left: 20px solid transparent;
        right: 0;
        top: 0;
        content: "";
        z-index: 101;
    }

    .box:after {
        position: absolute;
        display: block;
        content: "\2714";
        top: -3px;
        right: 0;
        font-family: Glyphicons Halflings;
        font-size: 3pt;
        font-weight: normal;
        z-index: 102;
        color: #fff;
    }

    .img-div {
        margin: 10px 45px;
    }

    .detail-table {
        margin-top: 20px;
    }
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" class="detail-form">
                    <div class="detail-form-parent-div">
                        <div class="margin-bt-10">
                            <div class="detail-body-title">公司信息</div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="公司名称" prop="dealName">
                                    <el-input v-model="detailForm.dealName" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="公司简称" prop="dealAbbrName">
                                    <el-input v-model="detailForm.dealAbbrName" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="社会统一组织机构代码" prop="organizeNo">
                                    <el-input v-model="detailForm.organizeNo" size="small" maxlength="25"></el-input>
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="公司联系人1" prop="contactName">
                                    <el-input v-model="detailForm.contactName" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="公司联系人职务" prop="contactPosition">
                                    <el-input v-model="detailForm.contactPosition" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="联系方式" prop="contactPhone">
                                    <el-input v-model="detailForm.contactPhone" size="small" maxlength="25"></el-input>
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="公司联系人2" prop="contactNameTwo">
                                    <el-input v-model="detailForm.contactNameTwo" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="公司联系人职务" prop="contactPositionTwo">
                                    <el-input v-model="detailForm.contactPositionTwo" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="联系方式" prop="contactPhoneTwo">
                                    <el-input v-model="detailForm.contactPhoneTwo" size="small" maxlength="25"></el-input>
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="客服电话" prop="serviceTel">
                                    <el-input v-model="detailForm.serviceTel" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="微信商户全称" prop="wxMerchantName">
                                    <el-input v-model="detailForm.wxMerchantName" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="微信商户编号" prop="turnoverMerchantCode">
                                    <el-input v-model="detailForm.turnoverMerchantCode" size="small" maxlength="25"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="电流输出类型" prop="wxAccountNature ">
                                    <el-select class="full-width" v-model="detailForm.wxAccountNature" size="small" clearable>
                                        <el-option label="交流" value="01"></el-option>
                                        <el-option label="直流" value="02"></el-option>
                                    </el-select>
                                </el-form-item> -->
                            </div>
                            <div>
                                <el-form-item class="detail-form-logo" label="上传logo" prop="imgPath">
                                    <el-upload class="upload-demo upload-logo" action="" :http-request="toUploadLogoImg" :on-preview="handleLogoPreview" :on-remove="handleLogoRemove" :file-list="logoFileList" :limit="1" :before-upload="beforeAvatarUpload" list-type="picture">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传 jpg / jpeg / bmp / gif / png 文件，且不超过2M</div>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="公司简介" prop="dealerDesc">
                                    <el-input v-model="detailForm.dealerDesc" size="small" type="textarea" maxlength="200"></el-input>
                                </el-form-item>
                                <el-button v-if="editFlag" type="primary" size="small" style="float:right" @click="dialogVisible = true">选择APP中卡包样式</el-button>
                            </div>
                        </div>
                        <el-divider v-if="editFlag"></el-divider>
                        <div v-if="editFlag" class="margin-bt-10">
                            <div class="detail-body-title">绑定电站</div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="电站ID" prop="stationNo">
                                    <el-input v-model="stationDetailForm.stationNo" size="small" clearable></el-input>
                                </el-form-item>
                                <el-button style="height:32px;margin-top:54px;" size="small" type="primary" @click="addPileStation('Y')">绑定</el-button>
                            </div>
                            <el-table :data="stationTableData" :stripe="true" ref="listTableRef" border class="detail-table" height="300">
                                <el-table-column type="index" width="50" align="center">
                                </el-table-column>
                                <el-table-column label="电站编号" prop="stationNo" min-width="150" align="center">
                                </el-table-column>
                                <el-table-column label="电站名称" prop="stationName" min-width="150" align="center">
                                </el-table-column>
                                <el-table-column label="区域" prop="province" min-width="150" align="center">
                                </el-table-column>
                                <el-table-column label="详细地址" prop="stationAddr" min-width="150" align="center">
                                </el-table-column>
                                <el-table-column label="电桩" prop="pileNum" min-width="150" align="center">
                                </el-table-column>
                                <el-table-column label="备注" prop="stationRemark" min-width="150" align="center">
                                </el-table-column>
                                <el-table-column label="操作" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        <span @click="addPileStation('N',scope.row)"><a>解绑</a></span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <el-divider></el-divider>
                        <div class="margin-bt-10">
                            <div class="detail-body-title">运营商收款账户</div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="收款方银行卡号" prop="bankCard">
                                    <el-input v-model="detailForm.bankCard" size="small"></el-input>
                                </el-form-item>
                                <!-- <el-form-item class="detail-from-input" label="微信商户编号" prop="turnoverMerchantCode">
                                    <el-input v-model="detailForm.turnoverMerchantCode" size="small"></el-input>
                                </el-form-item> -->
                                <el-form-item class="detail-from-input" label="收款方用户名" prop="bankName">
                                    <el-input v-model="detailForm.bankName" size="small"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="银行卡所在开户行编号" prop="bankCode">
                                    <el-input v-model="detailForm.bankCode" size="small"></el-input>
                                </el-form-item>
                                <el-button style="height:32px;margin-top:54px;" size="small" type="primary" v-if="editFlag" @click="addBank('detailForm')">新增</el-button>
                            </div>
                            <div style="margin:20px 30px; font-size:14px;">帮助文档：<a href="https://pay.weixin.qq.com/wiki/doc/api/tools/mch_pay.php?chapter=24_4" target="_blank">https://support.qq.com/products/135458/faqs/90606</a></div>
                            <el-table v-if="editFlag" :data="dealerBankDtoList" :stripe="true" ref="listTableRef" border class="detail-table">
                                <el-table-column type="index" width="50" align="center">
                                </el-table-column>
                                <el-table-column label="收款方银行账号" min-width="150" align="center">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.bankCard}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="收款方用户名称" min-width="150" align="center">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.bankName}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="所在开户行编号" min-width="150" align="center">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.bankCode}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        <el-radio v-model="radio" :label="scope.$index" @change="selectBank(scope.row)">启用</el-radio>
                                        <a @click="delBank(scope.row)">删除</a>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <!-- 新需求删除合作协议内容 放到 -->
                        <el-divider></el-divider>
                        <div class="margin-bt-10">
                            <div class="detail-body-title">合作协议与分成</div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="设置每度电分成金额（元）" prop='profitShare'>
                                    <el-input-number style="width:200px" v-model="detailForm.profitShare" size="small" :precision="2" :step="0.01" :min="0" :max="1"></el-input-number>
                                </el-form-item>
                                <div style="font-size:14px;line-height:60px;">注：该金额我们为运营商订单中的分成金额请郑重填写。精确到0.01元</div>
                            </div>
                            <el-form-item class="detail-from-input" prop="fileAttach">
                                <el-upload class="upload-demo" action="" :http-request="toUploadcontractFile" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :on-exceed="handleExceed" :file-list="fileList">
                                    <a>上传合同附件</a>
                                    <div slot="tip" class="el-upload__tip"></div>
                                </el-upload>
                            </el-form-item>
                            <el-table v-if="editFlag" :data="dealerFileDtoList" :stripe="true" ref="listTableRef" style="width:50%" border class="detail-table">
                                <el-table-column type="index" width="50" align="center">
                                </el-table-column>
                                <el-table-column label="合同名称" min-width="150" align="center">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.fileName}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="上传时间" min-width="150" align="center">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.lastModifiedWhen}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        <el-radio v-model="fileRadio" :label="scope.$index" @change="selectFile(scope.row,scope.$index)">启用</el-radio>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-form-item class="detail-from-input" label="合同摘要" prop="contactSummary">
                                <el-input v-model="detailForm.contactSummary" size="small" type="textarea" :rows="4"></el-input>
                            </el-form-item>
                        </div>
                        <el-divider></el-divider>
                        <div class="margin-bt-10">
                            <div class="detail-body-title">运营商备注</div>
                            <el-form-item class="detail-from-input" prop="dealerRemark">
                                <el-input v-model="detailForm.dealerRemark" size="small" type="textarea" :rows="4" maxlength="250"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <el-dialog title="APP卡包样式" :visible.sync="dialogVisible" width="25%" :lock-scroll="true">
                    <div class="app-card-style">
                        <div class="img-div" :class="{'box':selectFlag==index+1}" v-for="(item,index) in imgArr" :key="index">
                            <img class="card-style-img" :src="'/api/v1'+item.configCont1" @click="handleCardStyleChange(index+1,item.configCont1)" alt="">
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                        <el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag: false, //表单是否编辑状态
                pageTitle: '运营商新增',
                // 默认值设置
                detailForm: {
                    profitShare: 0,
                },
                stationDetailForm: {}, //电站编号
                logoFile: null, //logo图标
                logoFileList: [], //logo预览文件
                dialogVisible: false, //app卡包样式弹窗
                selectFlag: '', //选中的卡包样式
                stationTableData: [], //绑定电站数据
                contractFile: null, //上传文件
                fileList: [], //上传文件预览地址
                dealerBankDtoList: [], //运营商收款账户数据
                dealerFileDtoList: [], //运营商table表单数据
                radio: '', //收款账号是否启用
                url: '', //请求数据的url地址
                ruleArr: [], //表单验证字段
                imgArr: [], //卡包样式数据列表
                fileRadio: '' //合同是否启用
            }
        },
        methods: {
            //是否为编辑模式
            init() {
                this.url = this.$A.dealer.add;
                // if(this.$store.state.editId){
                //     this.editFlag = true;
                //     this.pageTitle = "运营商编辑";
                //     this.getFormInfo();
                //     this.url = this.$A.dealer.edit; 
                //     this.ruleArr = this.pageConfig.editRuleArr;
                //     this.getConfig();
                // }else{
                //     this.ruleArr = this.pageConfig.addRuleArr;
                // }
                if (this.$route.query.editId) {
                    this.editFlag = true;
                    this.pageTitle = "运营商编辑";
                    this.getFormInfo();
                    this.url = this.$A.dealer.edit;
                    this.ruleArr = this.pageConfig.editRuleArr;
                    this.getConfig();
                } else {
                    this.ruleArr = this.pageConfig.addRuleArr;
                }
            },
            // 获取表单信息
            getFormInfo() {
                let _ = this;
                _.$S.getFormInfo(_, _.$A.dealer.dealer + '/' + _.$route.query.editId, function(res) {
                    _.detailForm = res.data.data;
                    _.detailForm.oldTurnoverMerchantCode = _.detailForm.turnoverMerchantCode
                    delete _.detailForm.bankCard;
                    delete _.detailForm.bankName;
                    delete _.detailForm.bankCode;
                    _.logoFileList = [];
                    if (_.detailForm.imgPath) {
                        let imgObj = {}
                        imgObj.name = 'logo';
                        imgObj.url = _.detailForm.imgPath;
                        _.logoFileList.push(imgObj);
                    }
                    _.stationTableData = _.detailForm.pileStationEntityList;
                    //  let fileObj = {};
                    //  fileObj.name = '合同附件';
                    //  fileObj.url = _.detailForm.fileAttach;
                    //  _.fileList.push(fileObj);
                    _.dealerBankDtoList = _.detailForm.dealerBankDtoList;
                    _.dealerBankDtoList.forEach((item, index) => {
                        if (item.status == "Y") {
                            _.radio = index;
                        };
                    })
                    _.dealerFileDtoList = _.detailForm.dealerFileDtoList;
                    _.dealerFileDtoList.forEach((item, index) => {
                        item.lastModifiedWhen = _.detailForm.lastModifiedWhen;
                        if (item.status == "Y") {
                            _.fileRadio = index;
                        };
                    })
                    let cardBackgroundPath = _.detailForm.cardBackgroundPath.split("0")[1];
                    let cardNum = cardBackgroundPath.split(".")[0];
                    let cardImgPath = '/api/v1' + _.detailForm.cardBackgroundPath;
                    _.handleCardStyleChange(cardNum, cardImgPath);
                });
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                _.detailForm.corpNo = _.$store.state.corpNo;
                delete _.detailForm.dealerBankDtoList;
                delete _.detailForm.dealerFileDtoList;
                delete _.detailForm.dealerCalcDto;
                _.detailForm.reportCalcDto = {};
                let formData = new FormData();
                Object.keys(_.detailForm).forEach((key) => {
                    formData.append(key, _.detailForm[key]);
                });
                formData.append('img', _.logoFile);
                // formData.append('file',_.contractFile);
                let num = 0;
                let suc = true;
                this.$refs[formName].validateField(_.ruleArr, valid => {
                    if (valid) {
                        suc = false;
                    }
                    num++;
                    if (num == _.ruleArr.length && suc) {
                        _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
                    }
                });
            },
            //上传logo图片
            toUploadLogoImg(param) {
                this.logoFile = param.file;
            },
            //清楚logo图片
            handleLogoRemove(file, fileList) {
                this.detailForm.imgPath = '';
                this.logoFile = null;
            },
            //预览logo
            handleLogoPreview(file) {
                console.log(file);
            },
            //上传logo图片限制
            beforeAvatarUpload(file) {
                let logoType = false;
                if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/gif' || file.type === 'image/png') {
                    logoType = true;
                }
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!logoType) {
                    this.$message.error('上传logo图片只能是 jpg / jpeg / bmp / gif / png 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传logo图片大小不能超过 2MB!');
                }
                return logoType && isLt2M;
            },
            //上传图片附件
            toUploadcontractFile(param) {
                let _ = this;
                if (param) {
                    this.contractFile = param.file;
                    if (this.editFlag) {
                        let formData = new FormData();
                        formData.append('dealerNo', this.detailForm.dealNo);
                        formData.append('file', this.contractFile);
                        this.$H.post(this, this.$A.dealer.addattach, formData).then(res => {
                            this.dealerFileDtoList.push(res.data.data)
                            _.detailForm.fileAttachDetail = res.data.data.fileAttachDetail;
                        })
                    }
                }

            },
            //获取卡包样式列表
            getConfig() {
                let _ = this;
                _.$H.post(_, _.$A.config.list, { configType: "193" }).then(res => {
                    _.imgArr = res.data.data;
                })
            },
            //删除合同附件
            handleRemove(file, fileList) {
                this.contractFile = null;
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            //删除附件前提示
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            //选择卡包样式
            handleCardStyleChange(val, cardImgPath) {
                this.selectFlag = val;
                if ('/api/v1' + this.detailForm.cardBackgroundPath != cardImgPath) {
                    this.detailForm.cardBackgroundPath = cardImgPath;
                }
            },
            //上传运营商收款账户信息
            addBank(formName) {
                let _ = this;
                let num = 0;
                let suc = true;
                this.$refs[formName].validateField(['bankCard', 'bankName', 'bankCode'], res => {
                    if (res) {
                        suc = false;
                    }
                    num++;
                    if (num == 3 && suc) {
                        num = num + 1;
                        let obj = {
                            bankCard: _.detailForm.bankCard,
                            bankName: _.detailForm.bankName,
                            bankCode: _.detailForm.bankCode,
                            dealerNo: _.detailForm.dealNo
                        };

                        _.$H.post(_, _.$A.dealer.addbank, obj).then(res => {
                            _.dealerBankDtoList.push(res.data.data)
                            _.detailForm.bankDetail = res.data.data.bankDetail;
                        })
                    }
                });

            },
            //启用运营商收款账户
            selectBank(row) {
                let _ = this;
                row.dealerNo = _.detailForm.dealNo;
                row.status = 'Y';
                _.$H.post(_, _.$A.dealer.editbank, row).then(res => {
                    _.$U.success("启用成功")
                    _.detailForm.bankDetail = res.data.data.bankDetail;
                })
            },
            //启用合同
            selectFile(row, index) {
                let _ = this;
                row.dealerNo = _.detailForm.dealNo;
                row.status = "Y";
                _.$H.post(_, _.$A.dealer.editattach, row).then(res => {
                    _.fileRadio = index;
                    _.$U.success("启用成功");
                    _.init();
                })
            },
            // 该功能已注销
            delFile(row) {
                let _ = this;
                row.dealerNo = _.detailForm.dealNo;
                _.$H.post(_, _.$A.dealer.removeattach, row).then(res => {
                    _.$U.success("删除成功")
                    _.init();
                })
            },
            //删除运营商银行账号信息
            delBank(row) {
                let _ = this;
                row.dealerNo = _.detailForm.dealNo;
                _.$H.post(_, _.$A.dealer.removebank, row).then(res => {
                    _.$U.success("删除成功")
                    _.init();
                })
            },
            //绑定/解绑 电站
            addPileStation(type, row) {
                let _ = this;
                let stationNo = '';
                if (row) {
                    stationNo = row.stationNo;
                } else {
                    stationNo = _.stationDetailForm.stationNo;
                }
                _.$U.showLoading(_);
                _.$H.get(_, _.$A.dealer.updstation + '/' + _.detailForm.id + '/' + stationNo + '/' + type, {}).then(res => {
                    _.stationTableData = res.data.data;
                    _.stationDetailForm.stationNo = '';
                    if (_.stationTableData.length == 0) {
                        if (type == 'Y') {
                            _.$U.error("未找到相关信息");
                        } else {
                            _.$U.success("解绑成功");
                        }
                    }
                    _.$U.hideLoading(_);
                })
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>